/* eslint-disable no-console */
//import { CellMeasurer } from "react-virtualized";
import { FormatR2Duration, FormatTitle, FormatTrackNumber } from "../Formatting";
import { ValidationInstructionIcon } from "../StatusIcons/Icons";
import { ValidationMessageTypeIcon } from "../StatusIcons/ValidationMessageTypeIcon";
import { IngestionMessage } from "../asset-service-api";
import { ProjectType, Resource } from "../api";
import { TrackBody } from "./TrackBody";
import { TrackGroupBody } from "./TrackGroupBody";
import { DraggableAudioResource } from "./Views/Drafts/UPC_Tracks/DraggableAudioResource";
import { ITrack } from "./MapData";

interface Column<D> {
    accessor: keyof D,
    Header: string,
    minWidth?: string;
    rowSpan?: number
    colSpan?: number
    class?: string
    Formatter?: Function
}

interface TrackRowProps {
    style: any
    projectId?: string /* The '?' makes projectId optional */
    track?: any
    projectType?: ProjectType
    normalView?: boolean
    multipleTrackGroups?: boolean
    showPrompt?: boolean
    iAudioResource?: Resource
    trackMsgs?: IngestionMessage[]
    validationInstructions: IngestionMessage[]
    hasValidationErrors: boolean
    hasValidationRestrictions: boolean
    hasValidationWarnings: boolean
    registerChild: any
}

const columns: Column<ITrack>[] = [
    {
        accessor: "number",
        Header: "Track",
        colSpan: 1,
        class: "center",
        Formatter: FormatTrackNumber,
    },
    {
        accessor: "title",
        Header: "Title",
        class: "word-break full-width",
        colSpan: 4,
        Formatter: FormatTitle,
    },
    {
        accessor: "duration",
        Header: "Duration",
        class: "numeric",
        Formatter: FormatR2Duration,
    },
    {
        accessor: "isrc",
        Header: "ISRC",
        class: "numeric",
        colSpan: 3,
    },
];

export const TrackRow = ({ style, projectId, projectType, track, hasValidationErrors, hasValidationRestrictions, hasValidationWarnings, trackMsgs, validationInstructions, normalView, multipleTrackGroups, showPrompt, iAudioResource, registerChild }: TrackRowProps) => {
    const hasMappedFile = iAudioResource !== undefined;
    const hasMessages = hasValidationErrors || hasValidationRestrictions || hasValidationWarnings;
    let trackMessages = trackMsgs;

    if (hasMessages) {

        if (normalView) { /* only display the first msg */
            trackMessages = trackMessages?.slice(0, 1);
        }
    }
    return <div ref={registerChild as any} style={{ ...style, border: 0, margin: 0, padding: 0 }}>
        <TrackBody key={`${track.number}bdy`} track={track}>
            <tr key={`${track.number}tbr`}>
                {columns.map(col => {
                    return (
                        <td key={col.accessor} rowSpan={col.rowSpan} colSpan={col.colSpan}
                            className={col.class} style={{ minWidth: col.minWidth }}>
                            {col.Formatter ? col.Formatter(track[col.accessor], track.versionTitle) : track[col.accessor]}
                            {!track.subTracks && col.Formatter === FormatR2Duration ? <span>&nbsp;&nbsp;&nbsp;</span> : null}
                        </td>
                    );
                },
                )}
            </tr>
            { /* AT-3498 added to handle track groups */
                track.subTracks ?
                    <TrackGroupBody key={`${track.number}sub`} subTracks={track.subTracks} />
                    : null
            }
            {iAudioResource ?
                <DraggableAudioResource
                    projectId={projectId!}
                    isOverlay={false}
                    isMapped={true}
                    hideTypeIcon={multipleTrackGroups}
                    reportView={!normalView}
                    // className={(isDurationEqual(track, iAudioResource)) ? 'alert-success' : 'alert-warning'}
                    key={iAudioResource.id}
                    audioResource={iAudioResource} />
                : null
            }
            {hasMessages
                ? trackMessages!.map(msg => {
                    return (
                        <tr key={`${track.number}warn`}>
                            <td rowSpan={1} className={"iconic"}>
                                <ValidationMessageTypeIcon messageType={msg.messageType!} />
                            </td>
                            <td colSpan={9}>
                                {msg.message}
                            </td>
                        </tr>
                    );
                })
                : null
            }
            {
                normalView && showPrompt && !hasMappedFile &&
                    !hasValidationWarnings &&
                    !hasValidationRestrictions &&
                    !hasValidationErrors
                    ? <tr key={`${track.number}info`}>
                        <td rowSpan={1} className={"status-iconic"}>
                            <ValidationInstructionIcon />
                        </td>
                        <td colSpan={9} className={"track-validation-instruction"}>
                            {validationInstructions[0]?.message ||
                                `Drop a file from the left to map it to this ${projectType === ProjectType.Resource ? "resource" : "track"}${multipleTrackGroups ? " group" : ""}`}
                        </td>
                    </tr>
                    : null
            }
        </TrackBody>
    </div>;
};
